// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"ed377a43","253":"78430ce3","348":"5416b46b","383":"960b6309","441":"ed377a43","644":"69892464","878":"b21a5be1","884":"93cec820","898":"d8e1f06f"}[chunkId] + ".chunk.css";
};